"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EUserPermissions;
(function (EUserPermissions) {
    EUserPermissions["VIEW_FACILITIES"] = "VIEW_FACILITIES";
    EUserPermissions["ADD_FACILITY"] = "ADD_FACILITY";
    EUserPermissions["DEACTIVATE_FACILITY"] = "DEACTIVATE_FACILITY";
    EUserPermissions["EDIT_FACILITY_INFORMATION"] = "EDIT_FACILITY_INFORMATION";
    EUserPermissions["EDIT_STATEMENT_SETTINGS"] = "EDIT_STATEMENT_SETTINGS";
    EUserPermissions["MODIFY_PAYER_TYPES"] = "MODIFY_PAYER_TYPES";
    EUserPermissions["VIEW_COLLECTIONS_FLOW"] = "VIEW_COLLECTIONS_FLOW";
    EUserPermissions["MODIFY_COLLECTIONS_FLOW"] = "MODIFY_COLLECTIONS_FLOW";
    EUserPermissions["VIEW_TEMPLATES"] = "VIEW_TEMPLATES";
    EUserPermissions["MODIFY_TEMPLATES"] = "MODIFY_TEMPLATES";
    EUserPermissions["VIEW_PAYMENT_ACCOUNT_AND_PAY_SETTINGS"] = "VIEW_PAYMENT_ACCOUNT_AND_PAY_SETTINGS";
    EUserPermissions["CONFIGURE_PAYMENTS_ACCOUNTS"] = "CONFIGURE_PAYMENTS_ACCOUNTS";
    EUserPermissions["EDIT_PAYMENT_SETTINGS"] = "EDIT_PAYMENT_SETTINGS";
    EUserPermissions["VIEW_RESIDENTS"] = "VIEW_RESIDENTS";
    EUserPermissions["EDIT_RESIDENT_SETTINGS"] = "EDIT_RESIDENT_SETTINGS";
    EUserPermissions["EDIT_CONTACT_SETTINGS"] = "EDIT_CONTACT_SETTINGS";
    EUserPermissions["MODIFY_PAYMENT_METHOD"] = "MODIFY_PAYMENT_METHOD";
    EUserPermissions["ADD_HISTORY_NOTE"] = "ADD_HISTORY_NOTE";
    EUserPermissions["MAKE_PAYMENT"] = "MAKE_PAYMENT";
    EUserPermissions["CREATE_AUTOPAY"] = "CREATE_AUTOPAY";
    EUserPermissions["DELETE_AUTOPAY"] = "DELETE_AUTOPAY";
    EUserPermissions["CREATE_SCHEDULED_PAYMENT"] = "CREATE_SCHEDULED_PAYMENT";
    EUserPermissions["DELETE_SCHEDULED_PAYMENT"] = "DELETE_SCHEDULED_PAYMENT";
    EUserPermissions["REFUND_PAYMENT"] = "REFUND_PAYMENT";
    EUserPermissions["VIEW_PAYMENTS"] = "VIEW_PAYMENTS";
    EUserPermissions["VIEW_PAYMENTS_DASHBOARD"] = "VIEW_PAYMENTS_DASHBOARD";
    EUserPermissions["REVIEW_PAYMENTS"] = "REVIEW_PAYMENTS";
    EUserPermissions["VIEW_DEPOSITS"] = "VIEW_DEPOSITS";
    EUserPermissions["VIEW_MAILINGS"] = "VIEW_MAILINGS";
    EUserPermissions["MODIFY_BATCH_MANUALLY"] = "MODIFY_BATCH_MANUALLY";
    EUserPermissions["MAIL_STATEMENTS"] = "MAIL_STATEMENTS";
    EUserPermissions["REVIEW_STATEMENTS"] = "REVIEW_STATEMENTS";
    EUserPermissions["UPDATE_STATEMENT"] = "UPDATE_STATEMENT";
    EUserPermissions["VIEW_COLLECTIONS"] = "VIEW_COLLECTIONS";
    EUserPermissions["REVIEW_COLLECTIONS"] = "REVIEW_COLLECTIONS";
    EUserPermissions["VIEW_USERS"] = "VIEW_USERS";
    EUserPermissions["MODIFY_USERS"] = "MODIFY_USERS";
    EUserPermissions["VIEW_PERMISSIONS"] = "VIEW_PERMISSIONS";
    EUserPermissions["MODIFY_ROLES"] = "MODIFY_ROLES";
    EUserPermissions["EDIT_PERMISSIONS"] = "EDIT_ROLE_PERMISSIONS";
    EUserPermissions["RESIDENT_USER_PERMISSIONS"] = "RESIDENT_USER_PERMISSIONS";
    EUserPermissions["DELETE_BATCH"] = "DELETE_BATCH";
    EUserPermissions["SHOW_ONLY_ASSIGNED_BATCHES"] = "SHOW_ONLY_ASSIGNED_BATCHES";
    EUserPermissions["ALLOW_UPDATE_COMPLETED_BATCH"] = "ALLOW_UPDATE_COMPLETED_BATCH";
    EUserPermissions["ACCESS_TO_CLAIMS"] = "ACCESS_TO_CLAIMS";
    EUserPermissions["ACCESS_TO_CLAIMS_SETTINGS"] = "ACCESS_TO_CLAIM_SETTINGS";
    EUserPermissions["MODIFY_HMO"] = "MODIFY_HMO";
    EUserPermissions["PROCESS_HMO"] = "PROCESS_HMO";
    EUserPermissions["ACCESS_TO_BILLING_SETTINGS"] = "ACCESS_TO_BILLING_SETTINGS";
    EUserPermissions["VIEW_CLAIMS"] = "VIEW_CLAIMS";
    EUserPermissions["VIEW_AUTOPAY"] = "VIEW_AUTOPAY";
    EUserPermissions["EDIT_FACILITY_ADVANCED_SETTINGS"] = "EDIT_FACILITY_ADVANCED_SETTINGS";
})(EUserPermissions = exports.EUserPermissions || (exports.EUserPermissions = {}));
;
;
;
